import Swiper from "swiper";

class PopularPosts {
  constructor() {
    this.sliderInit();
  }
  sliderInit = () => {
    const popularSlider = new Swiper(".js-popular-slider", {
      grabCursor: true,
      slidesPerView: "auto",
    });
  };
}
export default PopularPosts;
